<template>
  <div>
    <div class="content">
      <div class="lald-case__block-head-child d-md-none mb-8">
        <div class="lald-case__block-head-child-info">Денис (5 лет)</div>
        <div class="lald-case__block-head-child-avatar">
          <img
            :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/laldICC/boy-avatar.png 2x`"
          />
        </div>
      </div>
      <div class="lald-case__block">
        <div class="lald-case__block-head">
          <div class="lald-case__block-head-title">Осмотр</div>
          <div class="lald-case__block-head-child d-none d-md-flex">
            <div class="lald-case__block-head-child-info">Денис (5 лет)</div>
            <div class="lald-case__block-head-child-avatar">
              <img
                :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/laldICC/boy-avatar.png 2x`"
              />
            </div>
          </div>
        </div>
        <div class="lald-case__block-body">
          <div class="lald-case__block-body-props">
            <div class="lald-case__block-body-prop">
              <div class="lald-case__block-body-prop-icon">
                <img
                  :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/laldICC/icon2-1.svg`"
                />
              </div>
              <div class="lald-case__block-body-prop-text">
                <p class="default-text">
                  Физическое развитие ребенка среднее, гармоничное.
                </p>
              </div>
            </div>
            <div class="lald-case__block-body-prop">
              <div class="lald-case__block-body-prop-icon">
                <img
                  :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/laldICC/icon2-2.svg`"
                />
              </div>
              <div class="lald-case__block-body-prop-text">
                <p class="default-text">
                  Сердечно-легочная деятельность в норме.
                </p>
              </div>
            </div>
            <div class="lald-case__block-body-prop">
              <div class="lald-case__block-body-prop-icon">
                <img
                  :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/laldICC/icon2-3.svg`"
                />
              </div>
              <div class="lald-case__block-body-prop-text">
                <p class="default-text">
                  Живот умеренно вздут, при пальпации незначительная
                  болезненность в околопупочной и правой подвздошной областях и
                  в эпигастрии.
                </p>
              </div>
            </div>
            <div class="lald-case__block-body-prop">
              <div class="lald-case__block-body-prop-icon">
                <img
                  :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/laldICC/icon2-4.svg`"
                />
              </div>
              <div class="lald-case__block-body-prop-text">
                <p class="default-text">Стул с задержкой до 3 дней, плотный.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="lald-case__tools">
        <div class="lald-case__back" @click="$emit('back')">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.25 19.5L3.75 12L11.25 4.5"
              stroke="#8B8E8E"
              stroke-width="1.5"
              stroke-linecap="square"
            />
            <path
              d="M5.25 12L20.25 12"
              stroke="#8B8E8E"
              stroke-width="1.5"
              stroke-linecap="square"
            />
          </svg>
          Назад
        </div>
        <div class="lald-case__buttons">
          <div
            class="lald-case__button button button_violet-solid"
            @click="$emit('toStep', 2)"
          >
            <svg
              width="15"
              height="20"
              viewBox="0 0 15 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.5 0C7.5 0 0 6.89656 0 12.4138C0 16.6035 3.35789 20 7.5 20C11.6421 20 15 16.6035 15 12.4138C15 6.89656 7.5 0 7.5 0ZM10.625 13.6782H8.75001V15.5747H6.24999V13.6782H4.37498V11.1494H6.24999V9.25285H8.75001V11.1494H10.625V13.6782Z"
                fill="white"
              />
            </svg>
            Назначить биохимический анализ
          </div>
          <div
            class="lald-case__button button button_orange-gradient"
            @click="$emit('toStep', 3)"
          >
            <svg
              width="24"
              height="26"
              viewBox="0 0 24 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.0793 6.35886C10.2537 5.53318 8.91001 5.53267 8.08382 6.35886L7.69434 6.74835L16.9582 16.0122L17.3481 15.6227C17.7478 15.2225 17.9682 14.6909 17.9682 14.1252C17.9682 13.5595 17.7483 13.0273 17.3481 12.6277L11.0793 6.35886Z"
                fill="white"
              />
              <path
                d="M17.6628 9.59815C17.6628 8.64906 17.2931 7.75634 16.6218 7.08502C15.6631 6.12578 14.2879 5.83023 13.0728 6.19839L17.51 10.6351C17.6106 10.303 17.6628 9.95463 17.6628 9.59815Z"
                fill="white"
              />
              <path
                d="M18.7771 4.92947C17.8899 4.04218 16.7795 3.41875 15.5659 3.12656C15.1568 3.0282 14.7455 3.27981 14.6471 3.68875C14.5486 4.09778 14.8003 4.50911 15.2093 4.60762C16.1499 4.83415 17.0112 5.31789 17.6999 6.00668C18.3887 6.69541 18.8725 7.55665 19.099 8.49736C19.183 8.84642 19.495 9.08093 19.8389 9.08093C19.8979 9.08093 19.9579 9.07397 20.0179 9.05955C20.4269 8.96109 20.6786 8.54966 20.5801 8.14068C20.2878 6.92712 19.6644 5.81671 18.7771 4.92947Z"
                fill="white"
              />
              <path
                d="M23.6974 8.20086C23.3732 6.13599 22.417 4.25967 20.932 2.77476C19.4471 1.28974 17.5708 0.333553 15.5059 0.00942362C15.0903 -0.0562351 14.7006 0.228235 14.6353 0.643769C14.5701 1.05935 14.8541 1.44914 15.2697 1.51439C17.0138 1.78825 18.5994 2.59657 19.8548 3.85196C21.1102 5.10734 21.9185 6.6929 22.1924 8.43715C22.2513 8.81271 22.5753 9.08083 22.9439 9.08083C22.9832 9.08083 23.023 9.07779 23.063 9.07149C23.4786 9.00624 23.7626 8.61645 23.6974 8.20086Z"
                fill="white"
              />
              <path
                d="M16.1402 24.4762H2.39343C1.85775 24.4762 1.64706 24.068 1.59522 23.9429C1.54337 23.8177 1.40373 23.3801 1.78249 23.0013L2.77591 22.0079C3.51379 22.5219 4.3771 22.7802 5.24098 22.7802C6.34595 22.7802 7.45143 22.3592 8.29286 21.5178L11.1365 18.6741C12.5955 19.1327 14.2204 18.7503 15.3213 17.6489L15.8809 17.0898L6.61712 7.82596L6.05752 8.38505C4.95661 9.48647 4.57423 11.1109 5.03227 12.5698L2.18858 15.414C0.689554 16.9131 0.527057 19.2488 1.69866 20.9308L0.705296 21.9242C0.0095572 22.6199 -0.188739 23.6168 0.187796 24.5259C0.56433 25.4349 1.40946 25.9996 2.39343 25.9996H16.1402C16.5609 25.9996 16.9019 25.6586 16.9019 25.2379C16.9019 24.8172 16.5609 24.4762 16.1402 24.4762ZM7.90845 14.7208L8.87328 13.756C9.17085 13.4589 9.65275 13.4589 9.95032 13.756C10.2479 14.0536 10.2479 14.536 9.95032 14.8336L8.9855 15.7984C8.83671 15.9472 8.64172 16.0213 8.44723 16.0213C8.25224 16.0213 8.05724 15.9472 7.90845 15.7984C7.61088 15.5008 7.61088 15.0184 7.90845 14.7208ZM5.62335 17.0059C5.92092 16.7089 6.40282 16.7089 6.7004 17.0059C7.0198 17.2988 7.03382 17.8025 6.72579 18.1089C6.41923 18.4168 5.91615 18.4025 5.62335 18.0835C5.32578 17.7859 5.32578 17.3035 5.62335 17.0059Z"
                fill="white"
              />
            </svg>
            Провести УЗИ органов брюшной полости
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Step2",
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/laldICC.scss";

.lald-case {
  &__block {
    &-body {
      &-prop {
        display: grid;
        grid-template-columns: 50px 1fr;
        gap: 20px;
        align-items: flex-start;

        &:not(:last-child) {
          margin-bottom: 16px;
        }

        &-text {
          margin: auto 0;
        }
      }
    }
  }
}
</style>